import { createContext } from '@shared/utils/createContext';
import type { GoLiveChecksContextValue } from './GoLiveChecks.types';

/**
 * Optional by design. Publish surfaces live all over the app (card post-checkout, messaging,
 * reminders, the editor); only the website editor mounts a host, and everywhere else this
 * returns `undefined` and the caller keeps its existing behaviour untouched.
 *
 * Reading a context costs nothing, so the twelve incidental publish surfaces pay no query, no
 * feature-flag fetch and no translation preload for a wizard they never show.
 */
export const [GoLiveChecksContextProvider, useGoLiveChecksContext] = createContext<GoLiveChecksContextValue | undefined>({
  name: 'GoLiveChecksContext',
  strict: false,
});
